import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "detail-hero-module-content" };
const _hoisted_2 = { class: "detail-hero-module-content-group" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "detail-hero-module-content-separator" }, null, -1);
const _hoisted_4 = { class: "detail-hero-module-content-count" };
const _hoisted_5 = { class: "sub-detail-hero-module" };
const _hoisted_6 = { class: "sub-detail-hero-module-website-anomalies" };
const _hoisted_7 = { style: { "display": "flex", "flex-direction": "row", "gap": "10px", "align-items": "center" } };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("i", { class: "pi pi-chevron-circle-right" }, null, -1);
const _hoisted_9 = ["src"];
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("span", null, "link", -1);
const _hoisted_11 = { class: "sub-detail-hero-module-website-selector" };
const _hoisted_12 = {
    key: 1,
    class: "sub-detail-hero-module-website-selector"
};
import OneReportLogo from "@/assets/one-report-logo.svg";
import EndpointsUrls from "@/onedesk-portal.userendpoints.json";
import OneDeskHeroModule from "@/components/atoms/OneDeskHeroModule.vue";
import OneDeskAnomalyColumn from "@/components/atoms/OneDeskAnomalyColumn.vue";
import OneDeskDropdown from "@/components/atoms/OneDeskDropdown.vue";
import { ref, watch } from "vue";
import { useRouter } from "vue-router";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WebsiteDisplayHeroModule',
    props: {
        websiteDetails: {}
    },
    setup(__props) {
        const router = useRouter();
        const props = __props;
        const selectedPublicWebsite = ref("");
        const selectedTechnicalWebsite = ref("");
        watch(() => props.websiteDetails?.siteName, (currentValue) => {
            selectedPublicWebsite.value = currentValue;
        }, { immediate: true });
        watch(selectedPublicWebsite, (currentValue) => {
            router.replace({
                name: "Website",
                params: { slug: currentValue },
            });
        });
        watch(selectedTechnicalWebsite, (currentValue) => {
            router.replace({
                name: "Website",
                params: { slug: currentValue },
            });
        });
        const openOneReportLink = () => {
            const websiteSlug = props.websiteDetails.slug;
            const link = EndpointsUrls.oneReportLink + "website/" + websiteSlug + "/global";
            window.open(link, "_blank");
        };
        return (_ctx, _cache) => {
            return (_ctx.websiteDetails)
                ? (_openBlock(), _createBlock(OneDeskHeroModule, {
                    key: 0,
                    for: "details"
                }, {
                    content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("span", _hoisted_2, _toDisplayString(props.websiteDetails.brand), 1),
                            _hoisted_3,
                            _createElementVNode("span", _hoisted_4, _toDisplayString(props.websiteDetails.sameBrandPublicWebsites.length + " websites"), 1)
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(OneDeskAnomalyColumn, {
                                    "anomalies-count": props.websiteDetails.anomalies ? props.websiteDetails.anomalies.length : 0
                                }, null, 8, ["anomalies-count"])
                            ]),
                            (_ctx.websiteDetails.isSiteFollowed)
                                ? (_openBlock(), _createBlock(OneDeskButton, {
                                    key: 0,
                                    class: "one-report-link-button",
                                    "with-radius": false,
                                    onClick: _cache[0] || (_cache[0] = ($event) => (openOneReportLink())),
                                    severity: "secondary"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_7, [
                                            _hoisted_8,
                                            _createElementVNode("img", { src: _unref(OneReportLogo) }, null, 8, _hoisted_9),
                                            _hoisted_10
                                        ])
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_11, [
                                _createVNode(OneDeskDropdown, {
                                    modelValue: selectedPublicWebsite.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedPublicWebsite).value = $event)),
                                    options: _ctx.websiteDetails.sameBrandPublicWebsites,
                                    filter: true,
                                    "full-width": false,
                                    "option-value": "code",
                                    "linera-label": true
                                }, {
                                    label: _withCtx(() => [
                                        _createTextVNode(" Public sites ")
                                    ]),
                                    _: 1
                                }, 8, ["modelValue", "options"])
                            ]),
                            (_ctx.websiteDetails.sameBrandTechnicalWebsites.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createVNode(OneDeskDropdown, {
                                        modelValue: selectedTechnicalWebsite.value,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedTechnicalWebsite).value = $event)),
                                        options: _ctx.websiteDetails.sameBrandTechnicalWebsites,
                                        class: "sub-detail-hero-module-website-selector",
                                        filter: true,
                                        lineraLabel: true,
                                        "full-width": false,
                                        "option-value": "code"
                                    }, {
                                        label: _withCtx(() => [
                                            _createTextVNode(" Technical sites ")
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue", "options"])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
